export const LOADING = "_LOADING"
export const LOADED = "_LOADED"
export const ERROR = "_ERROR"
export const WEBSOCKET_CONNECT = "WEBSOCKET_CONNECT"
export const WEBSOCKET_CONNECTED = "WEBSOCKET_CONNECTED"
export const WEBSOCKET_DISCONNECT = "WEBSOCKET_DISCONNECT"
export const WEBSOCKET_DISCONNECTED = "WEBSOCKET_DISCONNECTED"
export const WEBSOCKET_SEND_MESSAGE = "WEBSOCKET_SEND_MESSAGE"
